<template>
  <div>
    <v-dialog v-model="modal" max-width="400" persistent>
      <ManageItem
        :item-prop="current"
        :key="modalKey"
        @close=";(modalKey = !modalKey), (modal = false)"
        @confirm=";(modalKey = !modalKey), list(), (modal = false)"
      />
    </v-dialog>

    <v-dialog v-model="removeModal" max-width="400" persistent>
      <v-card class="card-pad text-center">
        <strong>{{ $t('Remover') }} Item</strong>

        <br />

        <div class="caption--text text-body-2 mb-4">
          {{ $t('Tem certeza de que deseja remover o item') }}
          {{ current.name }}?
        </div>

        <v-btn
          depressed
          :disabled="loading"
          @click="removeModal = false"
          class="ma-1 secondary-button"
        >
          Cancelar
        </v-btn>

        <v-btn
          depressed
          :loading="loading"
          class="ma-1 primary-button"
          @click="remove"
        >
          {{ $t('Remover') }}
        </v-btn>
      </v-card>
    </v-dialog>

    <div class="d-flex my-3">
      <v-spacer></v-spacer>
      <v-btn
        class="secondary-button mr-4"
        depressed
        @click=";(current = {}), (modalKey = !modalKey), (modal = true)"
      >
        {{ $t('Adicionar') }}
      </v-btn>
      <v-btn class="primary-button mr-0" depressed @click="filters = !filters">
        {{ filters ? $t('Fechar') : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div class="d-flex" v-if="filters">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="filter.name"
          :label="$t('Nome do item')"
          class="primary-input"
          outlined
          dense
          hide-details
          style="max-width: 400px"
        ></v-text-field>

        <v-btn class="primary-button ml-2 mt-1" depressed @click="list">
          Filtrar
        </v-btn>
      </div>
    </v-expand-transition>

    <v-data-table
      :no-data-text="$t('Nenhum item encontrado')"
      class="main-table"
      :headers="headers"
      :items="items"
      :items-per-page="20"
      hide-default-footer
      hide-default-header
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              @click=";(current = item), (modalKey = !modalKey), (modal = true)"
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon small dark> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              small
              color="#A42A2AD9"
              style="font-weight: bold"
              dark
              v-bind="attrs"
              @click=";(current = item), (removeModal = true)"
              v-on="on"
              depressed
            >
              <v-icon small color="white"> mdi-trash-can-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Excluir') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <div class="registros" v-if="items.length">
          <span> 1 - {{ items.length }} de {{ filter.totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="filter.page"
          :length="filter.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import ManageItem from './manageItem'
import Utils from '../../../../../Utils/FormatDate'

export default {
  name: 'ItensTab',

  components: {
    ManageItem,
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id

    this.list()
  },

  data() {
    return {
      removeModal: false,
      loading: false,
      current: {},
      modal: false,
      modalKey: false,
      filter: {
        page: 1,
      },
      filters: false,
      items: [],
      apiService: new ApiService(),
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Item',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Classe',
          align: 'center',
          value: 'inspectionRoutineChecklistItemClass.name',
        },
        {
          text: 'Criado em',
          align: 'center',
          sortable: false,
          value: 'createdAt',
        },
        {
          text: 'Ações',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
    }
  },

  methods: {
    remove() {
      this.loading = true
      this.apiService
        .delete(`inspectionRoutineChecklistItem/remove/${this.current.id}`)
        .then(() => {
          this.list()
          this.loading = false
          this.removeModal = false
          this.$toast.success('Item removido com sucesso!')
        })
        .catch(() => {
          this.loading = false
        })
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    list() {
      this.apiService
        .get('inspectionRoutineChecklistItem/list/paginate', this.filter)
        .then((response) => {
          this.items = response.content.items
          console.log(this.items)

          this.filter.totalPages = response.content.pager.totalPages
          this.filter.totalItems = response.content.pager.totalItems
        })
    },
  },

  watch: {
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
  },
}
</script>

<style></style>
